import { brandIdentityKey } from './brandIdentity';

export type StagedBrandCandidate = {
  id?: string;
  slug?: string;
  name?: string;
  aliases?: string[];
};

/**
 * Map a single-token search / brand filter onto a catalog brandId when it
 * matches a known candidate (phottix / Phottix / Photoolex). Multi-word and
 * unknown single tokens stay product-name searches.
 */
export function resolveStagedSearchBrandId(
  raw: string,
  candidates: StagedBrandCandidate[] = [],
): string | undefined {
  const q = String(raw || '').trim();
  if (!q || /\s/.test(q)) return undefined;
  const key = brandIdentityKey(q);
  if (!key) return undefined;

  const hit = candidates.find((brand) => {
    const ids = [brand.id, brand.slug, brand.name, ...(brand.aliases || [])];
    return ids.some((value) => value && brandIdentityKey(value) === key);
  });
  // Only known catalog / registry brands — slug-shaped product tokens (indra, flash)
  // must stay full-text searches, not brandId fetches.
  if (hit) return String(hit.slug || hit.id || '').toLowerCase() || undefined;
  return undefined;
}
